import React, { useState } from 'react';
import styles from './style/full_width_image_style.module.scss';

const FullWidthImage = ({ children, className, src, alt }) => {

    return (
        <div
            className={`${className ? (className + ' ') : ''}${styles['image-container']}`}
            style={{backgroundImage: `url(${src})`}}
        >
            {children}
        </div>
    );
};

export default FullWidthImage;
